import { observer } from 'mobx-react';
import i_ from 'i18next';
import React, { Fragment, useState } from 'react';

import TextField from '../commons/TextField';
import SelectField from '../commons/SelectField';
import EditDialog from '../commons/EditDialog';
import { Row, Column } from '../commons/Containers';

import Stores from '../../stores/Stores';
import UIStore from '../../stores/UIStore';
import { Check, CloudUpload } from '@material-ui/icons';
import {
  uploadGeral,
  uploadMeso,
  uploadMicro,
  uploadMunicipio,
} from '../../utils/ParticipacaoAPI';
import { CircularProgress } from '@material-ui/core';

const store = Stores.load('rodada', 'numero');

const TD = ({ file, participacao, done, upload, disabled }) => {
  const [loading, setLoading] = useState(false);
  return (
    <td style={{ textAlign: 'center' }}>
      {done ? (
        <Check style={{ color: 'green' }} />
      ) : disabled ? (
        <CloudUpload style={{ color: 'grey' }} />
      ) : loading ? (
        <CircularProgress />
      ) : (
        <Fragment>
          <input
            type="file"
            style={{ display: 'none' }}
            id={'up_' + participacao.cargo.id + '_' + file}
            onChange={e => {
              const file = e.target.files[0];
              if (!file) {
                return;
              }
              const formData = new FormData();
              formData.append('file', file);
              setLoading(true);
              upload(participacao.id, formData).then(() => {
                store.open();
                setLoading(false);
              });
            }}
          />
          <label
            htmlFor={'up_' + participacao.cargo.id + '_' + file}
            style={{ cursor: 'pointer' }}
          >
            <CloudUpload />
          </label>
        </Fragment>
      )}
    </td>
  );
};

class RodadaEdit extends React.Component {
  componentWillMount() {
    this.pesquisas = Stores.create('pesquisa');
    this.pesquisas.query();
  }

  save = () => {
    if (store.edit.id != null) {
      store
        .save()
        .then(() => UIStore.redo(store))
        .catch(UIStore.saveError);
    } else {
      store
        .create()
        .then(data => {
          if (this.props.onSave) {
            this.props.onSave(data);
          }
        })
        .then(() => UIStore.redo(store))
        .catch(UIStore.saveError);
    }
  };

  render() {
    this.item = store.edit != null ? store.edit : {};
    return (
      <EditDialog
        title={i_.t('rodada.title', {
          context: this.item.id ? 'edit' : 'new',
          label: this.item.nome,
        })}
        opened={store.edit != null}
        onCancel={() => (store.edit = null)}
        onSave={this.save}
      >
        <Row>
          <Column>
            <SelectField
              entity="rodada"
              field="pesquisa"
              item={this.item}
              list={this.pesquisas.list}
              labelFunc={m => m.nome}
              onChange={(e, i, p) =>               
                (this.item.numero = this.item.pesquisa ? this.item.pesquisa.rodadas.length + 1 : 1)
              }
            />

            <TextField
              entity="rodada"
              field="numero"
              item={this.item}
              disabled={true}
            />

            <TextField
              type="number"
              entity="rodada"
              field="amostra"
              item={this.item}
            />
            <TextField
              type="date"
              entity="rodada"
              field="inicio"
              item={this.item}
            />
            <TextField
              type="date"
              entity="rodada"
              field="fim"
              item={this.item}
            />
          </Column>

          {this.item.id && (
            <Column>
              <table cellPadding={5}>
                <thead>
                  <tr>
                    <th />
                    <th>Geral</th>
                    <th>Munic.</th>
                    <th>Micro</th>
                    <th>Meso</th>
                  </tr>
                </thead>
                <tbody>
                  {this.item.participacoes.map(p => (
                    <tr key={'k' + p.id}>
                      <td>{p.cargo.nome}</td>
                      <TD
                        file="geral"
                        participacao={p}
                        done={p.uploadedGeral}
                        upload={uploadGeral}
                      />
                      <TD
                        file="municipio"
                        participacao={p}
                        done={p.uploadedMunicipio}
                        disabled={!p.uploadedGeral}
                        upload={uploadMunicipio}
                      />
                      <TD
                        file="micro"
                        participacao={p}
                        done={p.uploadedMicro}
                        disabled={!p.uploadedGeral}
                        upload={uploadMicro}
                      />
                      <TD
                        file="meso"
                        participacao={p}
                        done={p.uploadedMeso}
                        disabled={!p.uploadedGeral}
                        upload={uploadMeso}
                      />
                    </tr>
                  ))}
                </tbody>
              </table>
            </Column>
          )}
        </Row>
      </EditDialog>
    );
  }
}

export default observer(RodadaEdit);



// WEBPACK FOOTER //
// ./src/components/rodada/Edit.js